export interface TaskProps {
  task_request_id: number;
  user_id: number;
  task_name: string;
  deadline: string;
  priority: string;
  description: string;
  department: string;
  project: string;
  assigned_to: number;
  file_path: string;
  status: number;
  request_date: string;
  last_modified: string;
  creator_name: string;
  approver_name: string;
  assigned_to_name: string;
}

export interface TaskListResponse {
  [key: number]: {
    data: TaskProps[];
    total_count: number;
  };
}

export const TaskListDefault: TaskListResponse = {
  0: {
    data: [],
    total_count: 0,
  },
};

export interface TaskItemProps extends TaskProps {
  statuses: {
    [key: number]: boolean;
  };
  can_be_deleted: boolean;
}

export interface TaskFilters {
  hash_pw: string | undefined;
  from_date: string | undefined;
  to_date: string | undefined;
  status: number[] | undefined;
  priority: string | undefined;
  task_name: string | undefined;
  department: string | undefined;
  project: string | undefined;
  creator_name: string | undefined;
  assigned_to_name: string | undefined;
  sort_by: string[] | undefined;
  limit: number | undefined;
  offset: number | undefined;
  locations: string[] | undefined;
}

export const TaskFiltersDefault: TaskFilters = {
  hash_pw: undefined,
  from_date: undefined,
  to_date: undefined,
  status: undefined,
  priority: undefined,
  task_name: undefined,
  department: undefined,
  project: undefined,
  creator_name: undefined,
  assigned_to_name: undefined,
  sort_by: undefined,
  limit: undefined,
  offset: undefined,
  locations: undefined,
};
